import React from "react";
/**
 * Render the column header for the week numbers.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function WeekNumberHeader(props) {
    return React.createElement("th", { ...props });
}
//# sourceMappingURL=WeekNumberHeader.js.map